// Fire-and-forget event tracker used by product cards (PoM ribbon click,
// Add-to-booking click). Never throws — analytics must never break UX.
import axios from "axios";
import { API } from "@/config";

const SESSION_KEY = "egr_analytics_session_id";

/** Per-session anonymous id kept in sessionStorage (non-sensitive, ephemeral). */
function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `anon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[analytics] sessionStorage unavailable:", e);
    return null;
  }
}

export function trackEvent(event, { productId = null, meta = null } = {}) {
  try {
    // Fire and forget — do not await, do not surface errors.
    axios.post(`${API}/analytics/track`, {
      event,
      product_id: productId,
      session_id: getSessionId(),
      meta: meta || undefined,
    }).catch(() => {});
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[analytics] trackEvent failed:", e);
  }
}
